import UserRoleCURModule from "@/modules/UserRoleCUR";

function CreateUserRolePage() {
    return (
        <UserRoleCURModule typePage='create' />
    )
}

export default CreateUserRolePage;